module.exports = __webpack_public_path__ + "static/img/边框11.ffb720a.svg";


//////////////////
// WEBPACK FOOTER
// ./src/views/decorativePainting/imgs/边框11.svg
// module id = ZaTz
// module chunks = 2